// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`PdpXsellCarousel general snapshot 1`] = `
<div class="pdp-xsell-carousel">
  <div class="carousel-wrap">
    <!----><button type="button" class="left-nav btn-reset text-right clickable"><span class="color-gray icon-caret-left xs-f-grande sm-f-xgrande md-f-xxgrande max-at-tweak"><span class="ada-tooltip">previous</span></span></button><button type="button" class="right-nav btn-reset text-left clickable"><span class="color-gray icon-caret-right xs-f-grande sm-f-xgrande md-f-xxgrande max-at-tweak"><span class="ada-tooltip">next</span></span></button></div>
</div>
`;
